var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickBoxIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.338,
    height: 58.338,
    viewBox: "0 0 58.338 58.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "form1icon",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16975",
    "data-name": "Path 16975",
    d: "M109.87,141.761v26.375a5.734,5.734,0,0,1-5.734,5.734h-34.4A5.734,5.734,0,0,1,64,168.136v-34.4A5.734,5.734,0,0,1,69.734,128H93.741",
    transform: "translate(-64 -116.532)",
    fill: "none",
    stroke: "#1f54cc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16976",
    "data-name": "Path 16976",
    d: "M244.113,48.752a2.3,2.3,0,0,0-3.328-.08l-1.773,1.765a1.147,1.147,0,0,0,0,1.621l1.626,1.623a1.147,1.147,0,0,0,1.626,0l1.729-1.72A2.331,2.331,0,0,0,244.113,48.752Zm-8.687,5.268L209.55,79.851a1.29,1.29,0,0,0-.331.563l-1.2,3.565a.56.56,0,0,0,.7.7l3.562-1.2a1.29,1.29,0,0,0,.563-.331l25.831-25.879a1.29,1.29,0,0,0,0-1.815l-1.426-1.433A1.29,1.29,0,0,0,235.426,54.02Z",
    transform: "translate(-187.357 -48)",
    fill: "#1f54cc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickBoxIcon);
export default __webpack_public_path__ + "static/media/tickBoxIcon.2d0924d0d4fc3f984d42e7a0f103a6e2.svg";
export { ForwardRef as ReactComponent };